/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import { make } from 'vuex-pathify';
import axios from 'axios';

const getDefaultState = () => ({
  authors: undefined,
  author: undefined,
  authorinfo: undefined,
  filters: undefined,
  genero: undefined,
  otraactividad: undefined,
  disciplinas: undefined,
  territorios: undefined,
  municipios: undefined,
  idioma: undefined,
  paneles: undefined,
  panel: undefined,
  condicion: undefined,
  porcentaje: undefined,
  loading: false,

});

const state = () => getDefaultState();

export const getters = {
  getAuthor: state => () => state.author,
  getAuthors: state => () => state.authors,
  getCategory: state => () => state.disciplinas,
  getTerritory: state => () => state.territorios,
  getLocality: state => () => state.municipios,
  getPanels: state => () => state.paneles,
  getGeneros: state => () => state.genero,
  getIdiomas: state => () => state.idioma,
  getOtraactividad: state => () => state.otraactividad,
  getCondicionlaboral: state => () => state.condicion,
  getPorcentajes: state => () => state.porcentaje,

};

export const mutations = {
  ...make.mutations(state),

  UPDATE_LOCALITY(state) {
    state.municipios = undefined;
  },

  // ADD_AUTHOR_PANEL(state, panel) {
  //   const paneles = state.author.userdatas.filter(currentPanel => currentPanel.id !== panel.id);
  //   state.author.userdatas = [...paneles, panel];
  // },

  // DELETE_AUTHOR_PANEL(state, panel) {
  //   state.author.userdatas = state.author.userdatas.filter(currentPanel => currentPanel.id !== panel.id);
  // },
};

export const actions = {
  async fetchAuthors({ commit }) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.get('/authors');
      commit('SET_AUTHORS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async resetLocality({ commit }) {
    commit('UPDATE_LOCALITY');
  },

  async fetchAuthor({ commit }, authorId) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.get(`/authors/${authorId}`);
      commit('SET_AUTHOR', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async postAuthor({ commit }, formData) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.post('/newArtist', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('SET_AUTHORINFO', data);
      window.Vue.$router.push('/');
      window.Vue.$toast.success('Usuario creado correctamente');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async postDiscipline({ commit }, formData) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.post('/newPanel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('SET_PANEL', data);
      // commit('ADD_AUTHOR_PANEL', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteDiscipline({ commit }, discId) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.post('/deleteBoard', { userdata_id: discId });
      commit('SET_PANEL', data);
      // commit('DELETE_AUTHOR_PANEL', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchDisciplinas({ commit, rootGetters }) {
    try {
      // commit('SET_LOADING', true);
      const currentLocale = rootGetters['localeModule/getLocale']();
      const { data } = await axios.get(`${currentLocale}/disciplina`);
      commit('SET_DISCIPLINAS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchGeneros({ commit, rootGetters }) {
    try {
      // commit('SET_LOADING', true);
      const currentLocale = rootGetters['localeModule/getLocale']();
      const { data } = await axios.get(`${currentLocale}/genero`);
      commit('SET_GENERO', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchOtraActividad({ commit, rootGetters }) {
    try {
      // commit('SET_LOADING', true);
      const currentLocale = rootGetters['localeModule/getLocale']();
      const { data } = await axios.get(`${currentLocale}/otraactividad`);
      commit('SET_OTRAACTIVIDAD', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchIdiomas({ commit, rootGetters }) {
    try {
      // commit('SET_LOADING', true);
      const currentLocale = rootGetters['localeModule/getLocale']();
      const { data } = await axios.get(`${currentLocale}/idioma`);
      commit('SET_IDIOMA', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchTerritorios({ commit, rootGetters }) {
    try {
      const currentLocale = rootGetters['localeModule/getLocale']();
      commit('SET_LOADING', true);
      const { data } = await axios.get(`${currentLocale}/territorio`);
      commit('SET_TERRITORIOS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchMunicipios({ commit }, terId) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.get(`/municipio/${terId}`);
      commit('SET_MUNICIPIOS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchPaneles({ commit, rootGetters }) {
    try {
      const currentLocale = rootGetters['localeModule/getLocale']();
      // commit('SET_LOADING', true);
      const { data } = await axios.get(`${currentLocale}/paneles`);
      commit('SET_PANELES', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchCondition({ commit, rootGetters }) {
    try {
      // commit('SET_LOADING', true);
      const currentLocale = rootGetters['localeModule/getLocale']();
      const { data } = await axios.get(`${currentLocale}/condicionlaboral`);
      commit('SET_CONDICION', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchPorcentaje({ commit }) {
    try {
      // commit('SET_LOADING', true);
      const { data } = await axios.get('/porcentaje');
      commit('SET_PORCENTAJE', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async editDiscipline({ commit }, formData) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.post('/updatePanel', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      commit('SET_PANEL', data);
      // commit('ADD_AUTHOR_PANEL', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
